import { Coupon } from '@core/models/swagger';
import { createAction, props } from '@ngrx/store';

export enum ProjectActions {
  ResetCoupon = '[Flow Data Coupon] Reset coupon',
  UpdateCoupon = '[Flow Data Coupon] Update Coupon',
}

export const ResetCoupon = createAction(ProjectActions.ResetCoupon);

export const UpdateCoupon = createAction(ProjectActions.UpdateCoupon, props<{ data: Coupon }>());
